export class BarometerTab {
    constructor(public tabType: TabType, public title: string) {}
}

export enum TabType {
    Snapshot = 'Snapshot',
    Evolution = 'Evolution',
    Info = 'Info'
}
